import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "flightDetails/fetch";
    ActionTypes["fetchReset"] = "flightDetails/fetchReset";
    ActionTypes["fetchSuccess"] = "flightDetails/fetchSuccess";
    ActionTypes["fetchError"] = "flightDetails/fetchError";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, (options) => ({
        payload: { clearFlight: options?.clearFlight ?? true }
    })),
    fetchReset: createAction(ActionTypes.fetchReset, () => ({
        payload: {}
    })),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (flight) => ({
        payload: { flight }
    })),
    fetchError: createAction(ActionTypes.fetchError, (error) => ({
        payload: { error }
    }))
};
